// 合同模板
const contractTemplateJurisdiction = [
  { id: "015001001", label: "上传", children: [] },
  { id: "015001002", label: "删除", children: [] }
];

// 通知单模板
const noticeTemplateJurisdiction = [
  { id: "015003001", label: "上传", children: [] },
  { id: "015003002", label: "删除", children: [] }
];

// 孵化协议模板
const hatchTemplateJurisdiction = [
  { id: "015004001", label: "上传", children: [] },
  { id: "015004002", label: "删除", children: [] }
];

const documentServiceJurisdictionChildren = [
  {
    id: "015001000",
    label: "合同模板",
    routerName: "contract-template",
    children: contractTemplateJurisdiction
  },
  {
    id: "015003000",
    label: "通知单模板",
    routerName: "notice-template",
    children: noticeTemplateJurisdiction
  },
  // {
  //   id: "015004000",
  //   label: "孵化协议模板",
  //   routerName: "hatch-template",
  //   children: hatchTemplateJurisdiction
  // },
  {
    id: "015002000",
    label: "操作日志",
    routerName: "document-log",
    children: []
  }
];

const documentServiceJurisdiction = {
  id: "015",
  label: "智慧文书",
  children: documentServiceJurisdictionChildren
};

export { documentServiceJurisdiction };



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/documentServiceJurisdiction.js